import React from 'react';
import { HelpbotOption } from './HelpbotOption';
const HelpbotOptions = ({ options }) => React.createElement(React.Fragment, null, options.map((o) => React.createElement(HelpbotOption, { key: o.value.toString(), option: o })));
export { HelpbotOptions };
